import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import {
  SITE_MARKETPLACE_PATH,
  SITE_NAV_ROUTES,
  SITE_OSHAR_REAL_ESTATE_PATH,
  SITE_PUBLIC_LIBRARY_PATH,
} from "../../../constants/siteNavRoutes";
import { trackHomepageCtaClick } from "../../../utils/analytics";

const ITEMS = [
  {
    status: "available",
    label: "Available now",
    title: "Rise of Koraxos · Library",
    detail: "Novel and Genesis NFT comic editions — read, collect, and own story canon from the official library.",
    cta: "Visit the Library",
    to: SITE_PUBLIC_LIBRARY_PATH,
  },
  {
    status: "available",
    label: "Available now",
    title: "Treydorex (TRDX)",
    detail: "Utility token for future game and Oshar access — purchase and holder benefits on the home TRDX section.",
    cta: "View TRDX access",
    to: SITE_NAV_ROUTES.TOKEN_SALE,
    hashLink: true,
  },
  {
    status: "available",
    label: "Available now",
    title: "Free player dashboard",
    detail: "Create an account or connect a wallet for dashboard and My Library — no TRDX balance required for site access.",
    cta: "Open dashboard",
    to: SITE_NAV_ROUTES.DASHBOARD,
  },
  {
    status: "available",
    label: "Available now",
    title: "Oshar VR real estate",
    detail: "Virtual districts and parcel tiers — browse live tiers and genesis drops on Treydora.com.",
    cta: "Browse Oshar estates",
    to: SITE_OSHAR_REAL_ESTATE_PATH,
  },
  {
    status: "soon",
    label: "Coming soon",
    title: "Marketplace",
    detail: "Creator storefronts and Oshar commerce — preview listings now; live checkout when the marketplace opens.",
    cta: "Marketplace preview",
    to: SITE_MARKETPLACE_PATH,
  },
  {
    status: "soon",
    label: "In development",
    title: "Open-world game",
    detail: "Unreal-scale Oshar exploration and faction play — follow Chronicles and roadmap milestones for launch windows.",
    cta: "Explore the world",
    to: SITE_NAV_ROUTES.WORLD,
  },
];

const HomeRpgAvailability = () => {
  const trackAvailabilityCta = (item) =>
    trackHomepageCtaClick({
      cta_id: `availability_${String(item.cta || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "")}`,
      section: "availability",
      label: item.cta,
      destination: item.to,
      status: item.status,
    });

  return (
    <section
      className="td-rpg-section td-rpg-availability"
      id="availability"
      aria-labelledby="td-availability-heading"
    >
      <div className="td-rpg-inner">
        <div className="td-rpg-section__head">
          <div className="td-rpg-ornament" />
          <p className="td-rpg-section__kicker" id="td-availability-heading">
            WHAT IS LIVE
          </p>
          <h2 className="td-rpg-section__title">AVAILABLE NOW · COMING SOON</h2>
          <p className="td-rpg-section__lead">
            Treydora is a dark sci-fi fantasy game universe — born from the Koraxos novel and comic,
            powered by TRDX for future play, and expanding into Oshar and the marketplace.
          </p>
        </div>
        <ul className="td-rpg-availability__grid">
          {ITEMS.map((item) => (
            <li
              key={item.title}
              className={`td-rpg-availability__card td-rpg-availability__card--${item.status}`}
            >
              <span className="td-rpg-availability__badge">{item.label}</span>
              <h3>{item.title}</h3>
              <p>{item.detail}</p>
              {item.hashLink ? (
                <HashLink smooth to={item.to} className="td-btn-outline" onClick={() => trackAvailabilityCta(item)}>
                  {item.cta}
                </HashLink>
              ) : (
                <Link to={item.to} className="td-btn-outline" onClick={() => trackAvailabilityCta(item)}>
                  {item.cta}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HomeRpgAvailability;
